import { render, staticRenderFns } from "./CreateTicketView.vue?vue&type=template&id=27761c75&scoped=true&"
import script from "./CreateTicketView.vue?vue&type=script&lang=js&"
export * from "./CreateTicketView.vue?vue&type=script&lang=js&"
import style0 from "./CreateTicketView.vue?vue&type=style&index=0&id=27761c75&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27761c75",
  null
  
)

export default component.exports